import { call, all, put, select, takeLatest } from 'redux-saga/effects';
import { changeTutorial, changeTutorialList, setLoadingList, TutorialActionTypes } from 'store/reducers/tutorial.reducer';

import Notification from 'utils/notifications';
import { getVideo, getVideos } from 'utils/web-api';

function* getTutorialsList({ payload }) {
  try {
    yield put(setLoadingList(true));
    const token = yield select(state => state.Auth.token);
    const response = yield call(getVideos, token, payload);
    yield put(changeTutorialList(response));
  } catch (error) {
    Notification('error', 'Ocorreu um erro inesperado, tente novamente mais tarde.');
  } finally {
    yield put(setLoadingList(false));
  }
}

function* getTutorial({ payload }) {
  try {
    yield put(changeTutorial({}));
    const token = yield select(state => state.Auth.token);
    const response = yield call(getVideo, token, payload);
    yield put(changeTutorial(response));
  } catch (error) {
    Notification('error', 'Ocorreu um erro inesperado, tente novamente mais tarde.');
  }
}

export default function* MySaga() {
  yield all([
    takeLatest(TutorialActionTypes.ASYNC_TUTORIALS_LIST, getTutorialsList),
    takeLatest(TutorialActionTypes.ASYNC_TUTORIAL, getTutorial)
  ]);
}
